import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import ComponentSaq from "../../components/ComponentSaq";
import { formDataSaqA } from "../../data/4.0/formDataSaqA";
class SaqA extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return <ComponentSaq type="A" formDataSaq={formDataSaqA} />;
  }
}

export default withRouter(SaqA);
